export default __webpack_public_path__ + "static/media/topMetrics.60b629ea.png";